export const SS_SUPPORT_EMAIL = "support@thespecsheet.com";
